module.exports = "/_next/static/images/ReadyToQuoteBgWavesRight-633a0436b4ae12b6935b2af80a053beb.svg";